module.exports = __webpack_public_path__ + "img/TMO_Betrieb.8ec3f2ed.svg";